var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pricing-features"},[_c('div',{staticClass:"pricing-features__container"},[_c('div',{staticClass:"content-meta"},[_c('hot-title',{attrs:{"tag":"h2"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"content-body",domProps:{"innerHTML":_vm._s(_vm.body)}})],1),_vm._v(" "),_c('div',{staticClass:"content-carousel"},[_c('hot-carousel',{attrs:{"component":{
          is: _vm.cardFeature,
          name: 'cardFeature',
          items: _vm.items,
        },"swiper-options":_vm.swiperOptions,"fraction-pagination":_vm.fractionPagination}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }